/* eslint-disable */
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as locales from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { Guid } from 'guid-typescript';

import { HttpClient } from '@angular/common/http';
import { HttpProxyService } from './http-proxy.service';
import { PropertyConfig } from 'app/model/shared/backend-api-response/property-config';
import { GolfPropertyApiResponse } from 'app/model/golf/backend-api-response/golf-property-api-response';
import { Golf } from 'app/model/golf/backend-api-response/golf';
import { GoogleAnalyticsScriptService } from '../../../../../shared/services/google-analytics-script.service';
import { environment } from '../../../../../../environments/environment';
import { PropertySettings } from 'model/shared/backend-api-response/property-settings';
declare let ga: Function;

@Injectable({
  providedIn: 'root',
})
export class AppDataService {
  //public constants: any;
  //public mockData: any;
  public dateFunctionConfig = {
    locale: 'enUS',
    dateFormat: 'dd/MM/yyyy',
    dateMediumFormat: 'MMM dd, yyyy',
    weekNameFormat: 'EEEE',
    timeFormat: 'hh:mm p',
  };
  public tenantId: string = '';
  public propertyId: string = '';

  private middlewareAPIDomain: string = '';
  public therapistDisplayIndicator: any = 'name';
  public propertyInfo: GolfPropertyApiResponse;
  private appName: string = 'golf';
  public serviceHeaders: any;
  public tenantFound: boolean = false;
  public bookingDaysOut: number = 999;
  public cloudPropertyData: Golf;

  public isGoogleTagManager = false;
  public tagGoogleManagerId = ''; //GTM-WW8GW8R
  public propertyname_book: string = '';
  public propertyname_config: string = '';
  public transactionID;
  public phoneNumberFormat: string = '';
  public irameTime: number = 9000;

  public countryCodeKey: string = 'alpha-2';
  styleTag: any;

  public noEmailTrigger: boolean = false;
  public confirmationNumberLength: number = 50;
  public cartLimit: number = 100;
  public paymentRetryInterval: number = 5000;
  public paymentRetryCounter: number = 10;
  public configData: string = 'wbe-property-service/property';
  public configUrl: string = 'wbe-property-service/property';
  public currentPropertyDate: string;

  //middlewareAPIPropertyNames
  public propertyAPIName: string = 'wbe-property-service/property';
  public cookieRequired: boolean = false;
  public isCookiePolicyAcceptanceRequired: boolean = false;
  public policyCookie: boolean;
  cookieExpDays: number;
  public pageTitle: string;
  public azureBlobTokenKey: any;
  public ga4Data!: {
    gaAgilysysId: string;
    gaCustomerId: string;
    isCustGaId: boolean;
  };
  private propertySettings: PropertySettings | undefined;
  constructor(private http: HttpProxyService, private httpService: HttpClient, private googleScript: GoogleAnalyticsScriptService) {}

  async load(middlewareAPIDomain, tenantId, propertyId, appName, serviceHeaders) {
    this.middlewareAPIDomain = middlewareAPIDomain;
    this.tenantId = tenantId;
    this.propertyId = propertyId;
    this.appName = appName;
    this.serviceHeaders = serviceHeaders;
    let initialAPI = await this.initialAPI().then(async () => {
      let propertyAPI = await this.propertyAPI().then(async () => {
        return true;
      });
      return propertyAPI;
    });
    return initialAPI;
  }
  defineLocales() {
    for (const locale in locales) {
      if (this.cloudPropertyData.countryCode.toLowerCase() === locales[locale].abbr) {
        defineLocale(locales[locale].abbr, locales[locale]);
      }
    }
  }

  private loadGoogleScript(propertySettings?: PropertySettings): void {
    this.ga4Data = {
      gaAgilysysId: environment?.GaAgilysysId || '',
      gaCustomerId: propertySettings?.gaCustomerId || '',
      isCustGaId: propertySettings?.isCustGaId || false,
    };

    sessionStorage.setItem('GA4Data', JSON.stringify(this.ga4Data));

    this.ga4Data && this.googleScript.loadGoogleScript();
  }

  async initialAPI() {
    let transID = localStorage.getItem(`${this.tenantId}-${this.propertyId}-transactionID`);
    if (transID == 'undefined' || transID === null) {
      this.generateUniqueID(this.tenantId, this.propertyId);
    } else {
      this.transactionID = JSON.parse(localStorage.getItem(`${this.tenantId}-${this.propertyId}-transactionID`)).value;
    }
    let url =
      this.middlewareAPIDomain +
      '/' +
      this.propertyAPIName +
      '/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.propertyId +
      '/appName/' +
      this.appName +
      '?' +
      new Date().getTime() +
      '&appName=golf';

    let awaithttpRes = await this.http
      .get(url, this.serviceHeaders)
      .toPromise()
      .then(async (response: Golf) => {
        if (response['Success']) {
          this.propertySettings = response?.propertySettings;

          this.tenantFound = true;
          this.cloudPropertyData = Object.assign({}, response);
          this.dateFunctionConfig = this.cloudPropertyData.dateFunctionConfig
            ? this.cloudPropertyData.dateFunctionConfig
            : this.dateFunctionConfig;
          if (this.cloudPropertyData.countryCode) this.defineLocales();
          this.isGoogleTagManager = this.cloudPropertyData.isGoogleTagManager
            ? this.cloudPropertyData.isGoogleTagManager
            : this.isGoogleTagManager;
          this.tagGoogleManagerId = this.cloudPropertyData.tagGoogleManagerId
            ? this.cloudPropertyData.tagGoogleManagerId
            : this.tagGoogleManagerId;

          let setPropertyRes = await this.setProperty().then(() => {
            return true;
          });
          return setPropertyRes;
        } else {
          this.tenantFound = false;
          return true;
        }
      });
    return awaithttpRes;
  }

  async getLocalJSON() {
    let url = 'https://rguestbookdev.blob.core.windows.net/golf/1/alpha-golf/json/uiMessageCofig.json?' + new Date().getTime();

    let localJSON = await this.http
      .get(url)
      .toPromise()
      .then(async (response) => {
        // this.rGuestGolfMessages = response['uiMessages'];
        return true;
      });
    return localJSON;
  }

  async propertyAPI() {
    let themeHttpRes;
    let propDetails = await this.getPropertyDetails().then(async () => {
      themeHttpRes = await this.processThemeService().then(async () => {
        return true;
      });
      return themeHttpRes;
    });
    return propDetails;
  }

  async getPropertyDetails() {
    let url =
      this.middlewareAPIDomain +
      '/wbe-golf-service/golf/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.propertyId +
      '/propertyInfo?appName=golf';
    let propInfo = await this.http
      .get(url, this.serviceHeaders)
      .toPromise()
      .then(
        async (response: GolfPropertyApiResponse) => {
          if (response['success']) {
            this.propertyInfo = Object.assign({}, response);
            this.bookingDaysOut =
              this.propertyInfo && this.propertyInfo['rBookConfig'] ? this.propertyInfo['rBookConfig'].bookingDaysOut : this.bookingDaysOut;
            this.currentPropertyDate = moment(this.propertyInfo['golfHeader']['propertyDTTM']).format('YYYY-MM-DD');
            /*  if (this.propertyInfo['rBookConfig']) {
              switch (this.propertyInfo['rBookConfig'].rBookTherapistDisplay) {
                case 1:
                  this.therapistDisplayIndicator = 'code';
                  break;
                case 2:
                  this.therapistDisplayIndicator = 'name';
                  break;
                case 3:
                  this.therapistDisplayIndicator = 'aka';
                  break;
                case 4:
                  this.therapistDisplayIndicator = 'noDisplay';
                  break;
                default:
                  this.therapistDisplayIndicator = 'name';
                  break;
              }
            } */
          } else this.tenantFound = false;
          return true;
        },
        (error) => {
          this.tenantFound = false;
        }
      );
    return propInfo;
  }

  async setProperty() {
    this.countryCodeKey = this.cloudPropertyData.countryCodeKey ? this.cloudPropertyData.countryCodeKey : this.countryCodeKey;

    this.dateFunctionConfig = this.cloudPropertyData.dateFunctionConfig
      ? this.cloudPropertyData.dateFunctionConfig
      : this.dateFunctionConfig;

    this.cartLimit = this.cloudPropertyData.cartLimit ? this.cloudPropertyData.cartLimit : 10;
    this.confirmationNumberLength = this.cloudPropertyData.confirmationNumberLength
      ? this.cloudPropertyData.confirmationNumberLength
      : this.confirmationNumberLength;
    this.paymentRetryInterval = this.cloudPropertyData.paymentRetryInterval
      ? this.cloudPropertyData.paymentRetryInterval
      : this.paymentRetryInterval;
    this.paymentRetryCounter = this.cloudPropertyData.paymentRetryCounter
      ? this.cloudPropertyData.paymentRetryCounter
      : this.paymentRetryCounter;

    this.pageTitle = this.cloudPropertyData.pageTitle ? this.cloudPropertyData.pageTitle : 'rGuest Book-Golf UI';

    this.cookieRequired = this.cloudPropertyData.permissions?.functionalPermissions?.isCookiePolicyRequired;
    this.isCookiePolicyAcceptanceRequired = this.cloudPropertyData.permissions?.functionalPermissions?.isCookiePolicyAcceptanceRequired;

    if (this.cookieRequired) {
      this.checkPolicyCookie();
    } else {
      this.googleAnalytics();
    }

    if (this.cloudPropertyData.UrlMap.MaintenaceStatus == 'true') {
      this.processThemeService().then(() => {
        this.tenantFound = true;
        return true;
      });
    } else {
      for (let prop in this.cloudPropertyData.PropNameKeyList) {
        if (prop == 'config') {
          this.propertyname_config = this.cloudPropertyData.PropNameKeyList[prop];
        }
      }
      return true;
    }
  }
  async processThemeService() {
    let themeHttpRes;
    let url = this.azureTokenAdd(this.cloudPropertyData.UrlMap.StylUrl + '?' + new Date().getTime());
    themeHttpRes = await this.httpService
      .get(url, { responseType: 'text' })
      .toPromise()
      .then(async (val: any) => {
        let style = val;
        let injectappthemes = this.injectStylesheet(style, 'golf-app-theme-from-adminportal').then(async (appthemes) => {
          return true;
        });
        return injectappthemes;
      });
    return themeHttpRes;
  }

  async injectStylesheet(css, id) {
    const head = document.head || document.getElementsByTagName('head')[0];
    this.styleTag = document.createElement('style');
    this.styleTag.type = 'text/css';
    this.styleTag.id = id;
    this.styleTag.textContent = css;
    head.appendChild(this.styleTag);
    return true;
  }

  //check cookie poliy in local
  checkPolicyCookie() {
    this.policyCookie = this.getPolicyCookie(`${this.tenantId}-${this.propertyId}-policyCookie`);
    if (this.policyCookie) {
      this.googleAnalytics();
    }
  }

  //get localstorage cookie policy
  getPolicyCookie(cname) {
    let name = `${cname}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let newupdatedate = new Date(c.substring(cname.length, c.length));
        this.setPolicyCookie(cname, newupdatedate, this.cookieExpDays ? this.cookieExpDays : 0);
        return true;
      }
    }
    return false;
  }

  //set cookie policy
  setPolicyCookie(cname, cvalue, exdays) {
    let expires;
    if (exdays != 0) {
      let d = new Date(cvalue);
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      expires = `expires=${d['toGMTString']()}`;
    }
    document.cookie = `${cname}=${cvalue};${expires ? expires : ''};path=/`;
  }

  //setup google Analytics
  googleAnalytics() {
    this.loadGoogleScript(this.propertySettings);

    if (this.isGoogleTagManager && this.tagGoogleManagerId !== '') {
      const googleTagManagerScript = document.createElement('script');
      googleTagManagerScript.innerText = `window.dataLayer = window.dataLayer || [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${this.tagGoogleManagerId}');`;
      document.head.appendChild(googleTagManagerScript);
    }
  }

  generateUniqueID(tenantId, propertyId) {
    this.transactionID = Guid.create();
    localStorage.setItem(`${tenantId}-${propertyId}-transactionID`, JSON.stringify(this.transactionID));
    console.log('Transaction ID is: ' + this.transactionID);
  }
  azureTokenAdd(imgUrl) {
    let imagePath = '';
    imagePath = imgUrl;
    if (imagePath && this.azureBlobTokenKey) {
      let arr = imagePath.split('?');
      if (arr.length > 1) {
        imagePath = imagePath + '&' + this.azureBlobTokenKey;
      } else {
        imagePath = imagePath + '?' + this.azureBlobTokenKey;
      }
    }

    return imagePath;
  }
}
